import {
  Button,
  Column,
  Container,
  Img,
  Link,
  Row,
  Section
} from '@react-email/components'
import { truncate } from 'lodash'
import { getInviteLink } from 'utils'

import {
  Email,
  Footer,
  Mapstack,
  SplitContent,
  Text,
  WhatIsMapstack
} from '@ms-email/components'
import { borderRadius } from '@ms-email/themes/border-radius'
import { button } from '@ms-email/themes/button'
import { typography } from '@ms-email/themes/typography'
import { getMembers } from '@ms-email/utils/get-members'
import { getOwner } from '@ms-email/utils/get-owner'
import { getOwnerName } from '@ms-email/utils/get-owner-name'

const LIMIT = 4

export function MemberInvitation(props) {
  const { workspace } = props

  const owner = getOwner(workspace)
  const fullname = getOwnerName(owner)

  return (
    <Email
      title={`Action required: ${fullname} invited you to join their workspace on Mapstack`}
      preview={'Member invitation'}
    >
      <Container style={{ paddingBlock: 64 }}>
        <Mapstack />
        <InvitationHeader workspace={workspace} />
        <SplitContent
          first={<WorkspaceDetails workspace={workspace} />}
          second={<MembersList workspace={workspace} />}
        />
        <WhatIsMapstack />
        <Footer />
      </Container>
    </Email>
  )
}

function InvitationHeader(props) {
  const { workspace } = props

  const owner = getOwner(workspace)
  const fullname = getOwnerName(owner)

  return (
    <Section>
      <Text
        style={{
          marginTop: 32,
          ...typography.h5
        }}
      >
        Access this workspace on Mapstack
      </Text>

      <Text
        style={{
          marginTop: 32,
          ...typography.body1
        }}
      >
        {fullname} has invited you to access their workspace called{' '}
        {workspace.name}.
      </Text>
    </Section>
  )
}

function WorkspaceDetails(props) {
  const { workspace } = props

  const inviteLink = getInviteLink({
    workspaceId: workspace?.id,
    workspaceName: workspace?.name,
    inviteId: workspace?.inviteId
  })

  return (
    <Section style={{ padding: 24 }}>
      <Row>
        <Column align='center'>
          <Img
            src={workspace.logo}
            alt='Owner Avatar'
            width={75}
            height={75}
            style={{ borderRadius: borderRadius.rounded }}
          />
        </Column>
      </Row>
      <Row>
        <Column
          align='center'
          style={{ paddingTop: 16 }}
        >
          <Text
            style={{
              ...typography.body1,
              fontWeight: 700
            }}
          >
            {workspace.name}
          </Text>
        </Column>
      </Row>
      <Row>
        <Column
          align='center'
          style={{ paddingTop: 16 }}
        >
          <Link href={inviteLink}>
            {truncate(inviteLink, {
              length: 45,
              omission: '...'
            })}
          </Link>
        </Column>
      </Row>
      <Row>
        <Column
          align='center'
          style={{ paddingTop: 16 }}
        >
          <Button
            href={inviteLink}
            style={button.primary('medium')}
          >
            Join now
          </Button>
        </Column>
      </Row>
    </Section>
  )
}

function MembersList(props) {
  const { workspace } = props

  const owner = getOwner(workspace)
  const members = getMembers(workspace)

  return (
    <Section style={{ padding: 24 }}>
      <Row>
        <Column align='center'>
          <Text
            style={{
              ...typography.body1,
              marginBlock: 0,
              fontWeight: 600
            }}
          >
            {owner?.firstName} and {members?.length} others have already joined
          </Text>
        </Column>
      </Row>
      <Row style={{ paddingTop: 16 }}>
        <Column align='center'>
          <Img
            src={owner?.avatar}
            alt='Owner'
            width={50}
            height={50}
            style={{
              display: 'inline-block',
              margin: 6,
              marginBottom: 0,
              borderRadius: borderRadius.rounded
            }}
          />
          {members.slice(0, LIMIT).map((member, index) => {
            return (
              <Img
                key={index}
                src={member?.avatar}
                alt='member'
                width={50}
                height={50}
                style={{
                  display: 'inline-block',
                  margin: 6,
                  marginBottom: 0,
                  borderRadius: borderRadius.rounded
                }}
              />
            )
          })}
        </Column>
      </Row>
    </Section>
  )
}
